import { getCurrDataCenter, getUrlWorkspace } from '@/service';
import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';
import { getTempToken } from '@/service/token';

const UrlMap = {
  availableImages: () => `${PREFIX.vapis_dc_ws(GROUPS.image)}/stack-artifacts/available-images`,
  downloadImage: (abstractId: string, id: string) =>
    `${PREFIX.vapis_dc_ws(GROUPS.image)}/system-images/${abstractId}/versions/${id}/downloads`,
  containerImages: () => `${PREFIX.vapis_dc_ws(GROUPS.image)}/stack-artifacts/available-container-images`,
};

interface AvailableImagesParams {
  /** 硬件资源限制；订单侧常以 JSON 字符串序列化后透传 */
  hardwareOr?: string;
  cpu?: string; // 处理器限制
  downloadType?: string; // HTTP | Docker
  name?: string;
  page?: number;
  limit?: number;
}

// 通用镜像列表
export function getAvailableImages(params?: AvailableImagesParams) {
  return get<{ items: any[]; totalItems: number }>(UrlMap.availableImages(), params);
}

// 通用镜像下载地址
export async function downloadCommonImageUrl(abstractId: string, id: string, { dc, ws }: { dc?: string; ws?: string } = {}) {
  try {
    const { accessToken } = await getTempToken({
      accessTokentTimeout: 1 * 60 * 60 * 24 * 365, // 1 year
      namespaces: [
        {
          namespace: '*',
          groups: [
            {
              group: GROUPS.image,
              resources: [
                {
                  resource: 'system-images/versions/downloads',
                  verbs: ['list'],
                },
              ],
            },
          ],
        },
      ],
      dataCenter: dc || getCurrDataCenter(),
      workspace: ws || getUrlWorkspace(),
    });
    const url = UrlMap.downloadImage(abstractId, id);
    const resUrl = `${url}?token=${accessToken}`;
    return resUrl;
  } catch (error) {
    console.log(error);
  }
}

export type ArtifactType = 'system_image' | 'runtime' | 'tool' | 'inference_framework' | 'ai_application';
// 容器镜像列表
export function getAvailableContainerImages(params?: AvailableImagesParams & { artifactType?: ArtifactType }) {
  return get<{ items: any[]; totalItems: number }>(UrlMap.containerImages(), params);
}
